// What the rosa filters on, and the fuoriquota rule. The positions themselves belong to
// `messages/domain.ts`: two pages parse them, and one parser is one meaning.

import type { ClubPlayerRead, TeamRead } from '@volee/api-client'

import { personName } from './labels.ts'

import type { PlayerPosition } from '../messages/index.ts'

export function playsAs(player: ClubPlayerRead, position: PlayerPosition): boolean {
  return player.position === position
}

/** Case- and accent-insensitive, because a roster is searched by a name typed in a hurry. */
export function matchesName(player: ClubPlayerRead, query: string): boolean {
  if (query.trim() === '') return true
  return fold(playerName(player)).includes(fold(query))
}

/** Cognome first, as every list of people in the product reads. Keeps its domain name for
 *  the roster's callers and delegates, so the spelling lives in one place. */
export function playerName(player: ClubPlayerRead): string {
  return personName(player)
}

/** Born before the annata the squad's Under year admits — by year of birth, never by age today. Why
 *  the API answers neither: services/api/docs/overview.md § «No age and no gender check». */
export function isOverAge(player: ClubPlayerRead, team: TeamRead, seasonYear: number): boolean {
  if (team.under_age === 0 || player.birth_date == null) return false
  // The season's own year, never `new Date`: a date-only string is midnight UTC, and every
  // zone behind it lands on the day before.
  const bornIn = Number(player.birth_date.slice(0, 4))
  return bornIn < seasonYear + 1 - team.under_age
}

function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
}
